import { render, staticRenderFns } from "./ultraGoods.vue?vue&type=template&id=98d64ce8&scoped=true&"
import script from "./ultraGoods.vue?vue&type=script&lang=js&"
export * from "./ultraGoods.vue?vue&type=script&lang=js&"
import style0 from "./ultraGoods.vue?vue&type=style&index=0&id=98d64ce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d64ce8",
  null
  
)

export default component.exports